/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AmountsResource
 */
export interface AmountsResource {
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    serviceAmountExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    serviceAmountIncludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    feesAmountExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    feesAmountIncludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    serviceTaxesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    feesTaxesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    totalAmountExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof AmountsResource
     */
    totalAmountIncludingTaxes: number;
}

/**
 * Check if a given object implements the AmountsResource interface.
 */
export function instanceOfAmountsResource(value: object): value is AmountsResource {
    if (!('serviceAmountExcludingTaxes' in value) || value['serviceAmountExcludingTaxes'] === undefined) return false;
    if (!('serviceAmountIncludingTaxes' in value) || value['serviceAmountIncludingTaxes'] === undefined) return false;
    if (!('feesAmountExcludingTaxes' in value) || value['feesAmountExcludingTaxes'] === undefined) return false;
    if (!('feesAmountIncludingTaxes' in value) || value['feesAmountIncludingTaxes'] === undefined) return false;
    if (!('serviceTaxesAmount' in value) || value['serviceTaxesAmount'] === undefined) return false;
    if (!('feesTaxesAmount' in value) || value['feesTaxesAmount'] === undefined) return false;
    if (!('totalAmountExcludingTaxes' in value) || value['totalAmountExcludingTaxes'] === undefined) return false;
    if (!('totalAmountIncludingTaxes' in value) || value['totalAmountIncludingTaxes'] === undefined) return false;
    return true;
}

export function AmountsResourceFromJSON(json: any): AmountsResource {
    return AmountsResourceFromJSONTyped(json, false);
}

export function AmountsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmountsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceAmountExcludingTaxes': json['serviceAmountExcludingTaxes'],
        'serviceAmountIncludingTaxes': json['serviceAmountIncludingTaxes'],
        'feesAmountExcludingTaxes': json['feesAmountExcludingTaxes'],
        'feesAmountIncludingTaxes': json['feesAmountIncludingTaxes'],
        'serviceTaxesAmount': json['serviceTaxesAmount'],
        'feesTaxesAmount': json['feesTaxesAmount'],
        'totalAmountExcludingTaxes': json['totalAmountExcludingTaxes'],
        'totalAmountIncludingTaxes': json['totalAmountIncludingTaxes'],
    };
}

export function AmountsResourceToJSON(value?: AmountsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'serviceAmountExcludingTaxes': value['serviceAmountExcludingTaxes'],
        'serviceAmountIncludingTaxes': value['serviceAmountIncludingTaxes'],
        'feesAmountExcludingTaxes': value['feesAmountExcludingTaxes'],
        'feesAmountIncludingTaxes': value['feesAmountIncludingTaxes'],
        'serviceTaxesAmount': value['serviceTaxesAmount'],
        'feesTaxesAmount': value['feesTaxesAmount'],
        'totalAmountExcludingTaxes': value['totalAmountExcludingTaxes'],
        'totalAmountIncludingTaxes': value['totalAmountIncludingTaxes'],
    };
}

